import { ChatBubble, WhatsApp } from '@mui/icons-material'
import { Box, Tooltip } from '@mui/material'
import { FC } from 'react'

const TAWK_URL =
  'https://tawk.to/chat/5d95168fdb28311764d6fbcf/default?locale=pt_BR'
const WHATSAPP_URL = 'https://wa.me/5547991960430'

const iconSx = {
  borderRadius: 10000,
  position: 'fixed' as const,
  right: 15,
  padding: 2,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.5)',
  cursor: 'pointer',
  transition: 'transform 0.2s',
  '&:hover': { transform: 'scale(1.1)' },
}

const Chat: FC = () => {
  return (
    <Box>
      <Tooltip
        title="WhatsApp"
        arrow
        placement="left"
        componentsProps={{
          tooltip: {
            sx: {
              fontSize: '0.95rem',
              fontWeight: 600,
              bgcolor: 'rgba(0, 0, 0, 0.85)',
              py: 1.25,
              px: 2,
              boxShadow: 2,
            },
          },
        }}
      >
        <Box
          component="a"
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            ...iconSx,
            backgroundColor: 'rgba(35, 211, 102, 1.0)',
            bottom: 86,
          }}
        >
          <WhatsApp fontSize="large" sx={{ color: 'white' }} />
        </Box>
      </Tooltip>

      <Tooltip
        title="Atendimento"
        arrow
        placement="left"
        componentsProps={{
          tooltip: {
            sx: {
              fontSize: '0.95rem',
              fontWeight: 600,
              py: 1.25,
              px: 2,
              boxShadow: 2,
            },
          },
        }}
      >
        <Box
          component="a"
          href={TAWK_URL}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            ...iconSx,
            backgroundColor: '#000046',
            bottom: 8,
          }}
        >
          <ChatBubble fontSize="large" sx={{ color: 'white' }} />
        </Box>
      </Tooltip>
    </Box>
  )
}

export default Chat
